// extracted by mini-css-extract-plugin
export default {"tooltip":"kR-z","arrow":"lR-z"};